export enum SubrentalCutoffEnums {
  //Estados:
  open = 1,
  liquidated = 2,
  closed = 3
}